import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'main-tai-chi': {
			// ?safe&mock-data&utm_source=google&country=US&area=main-tai-chi&exp=web_welcome_for_google_tai_chi_gs~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_welcome_for_google_tai_chi_gs'),
			},
		},
	},
]

export default config
